import ComboBox from "../../Control/ComboBox/ComboBox";
import { ColumnLabel } from "../../Layout/ColumnLabel";
import { useEffect, useState } from "react";
import { ComboBoxOption } from "../../../models/Input";
import { opusOptions, opusStringToId } from "../../../models/Opus";

export type OpusSelectorOptions = "all" | "unique";

export type OpusSelectorProps = {
    values: ComboBoxOption<number>[] | null,
    update: (values: ComboBoxOption<number>[] | null) => void,
    options?: OpusSelectorOptions
}

export function OpusSelector(props: OpusSelectorProps) {
    const getOptions = (options: "all" | "unique" | undefined) => {
        const all = JSON.parse(JSON.stringify(opusOptions)) as ComboBoxOption<number>[];
        if (!options || options === "all") {
            return all;
        }

        if (options === "unique") {
            const exclude: number[] = [opusStringToId["A"], opusStringToId["B"], opusStringToId["C"], opusStringToId["Re"]];
            return all.filter(x => !exclude.includes(x.value));
        }

        return all;
    }

    const [options, setOptions] = useState<ComboBoxOption<number>[]>(getOptions(props.options));

    useEffect(() => {
        setOptions(getOptions(props.options));
    }, [props.options]);

    return (
        <ColumnLabel label="Opus">
            <ComboBox
                selections={props.values}
                isMulti={true}
                isClearable={true}
                options={options}
                onChange={(newSelections) => props.update(newSelections ? JSON.parse(JSON.stringify(newSelections)) : null)} />
        </ColumnLabel>
    )
}